import { Component } from '@angular/core';
import { BnplService } from '../../shared/services/bnpl.service';
import { Observable } from 'rxjs';
import { ActivityContractor } from '../../shared/models/general-parameters-response.model';
import { MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-modal-cancel',
  templateUrl: './modal-cancel.component.html',
  styleUrls: ['./modal-cancel.component.css']
})
export class ModalCancelComponent {

  cancelSeleccionado: any;
  opcionesCancelacion: Observable<ActivityContractor[]>;
  navigationExtras: NavigationExtras = {} 


  constructor(
    private bnplService: BnplService,
    public dialogRef: MatDialogRef<ModalCancelComponent>,
    private readonly router: Router,
  ) {
    const data = {
      id: 0,
      httpMethod: 'GET',
    };
    this.opcionesCancelacion = this.bnplService.getCausalDenied(data);
  }

  cerrarModal() {
    this.dialogRef.close();
  }

  mostrarModalFuncionalidad() {
    const data = {
      actionStrategyPattern: "DECLINED",
      "id": this.bnplService.personalInformation.id || localStorage.getItem('id'),
      "msjDeclined": this.cancelSeleccionado
    }
    this.bnplService.creditDenied(data).subscribe({
      next: async (resp: any) => {

        if ( resp.validationStrategy == 'CREDIT_DICLENED') {
          window.location.href = this.bnplService.personalInformation.urlRedirect;
        }

        this.navigationExtras = {state: resp}

        if (resp.showMessage == 2) {
          Swal.close();
          this.cerrarModal()
          this.router.navigate(['/await-alert', 'error'], this.navigationExtras);
        }
        if (resp.errorMessage) {
          Swal.close();
          this.cerrarModal()
          this.router.navigate(['/await-alert', 'error-connection']);
        }
      }, error: (e: any) => {
        Swal.close();
        this.cerrarModal()
        this.router.navigate(['/await-alert', 'error-connection']);
        console.log('error', e)
      }
    })
  }
}